module.exports = __webpack_public_path__ + "img/pending-error-clock-alert-outline.8b17cae7.svg";